module.exports = __webpack_public_path__ + "img/58ad14ebN0a8d1f14.b0387e83.jpg";